
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30318',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30318",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54632",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8034",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11493",
  "I18n": "static-7-hdineen_hubspot-i18n-react-compiler.2",
  "quartz": "static-1.7058",
  "quartz-config": "static-1.836",
  "quartz-core": "static-1.6277",
  "react-dlb": "static-1.79",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.798",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.54619",
  "feedback-utils": "static-1.54623",
  "forms-embed-utils-lib": "static-1.4484",
  "forms-utils-lib": "static-1.12625",
  "foundations-assets": "static-1.4889",
  "foundations-components": "static-1.7978",
  "foundations-theming": "static-1.4441",
  "hub-http": "static-1.6242",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11800",
  "icons": "static-2.650",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.3932",
  "raven": "static-3.5925",
  "react": "static-7.186",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1-feature-id-1459-skip-old-browsers.3",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5360",
  "react-virtualized": "static-2.99",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.487",
  "tinymce-plugins": "static-1.57548",
  "transmute": "static-2.85",
  "ui-images": "static-2.1160",
  "UIComponents": "static-3.8439",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3414",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3335",
  "quartz-webpack": "static-1.3282",
  "foundations-theming-specialty": "static-1.2157",
  "property-description-translator": "static-1.3864",
  "HeadJS": "static-2.764",
  "framer-motion": "static-1.72",
  "hs-test-utils-bend-plugin": "static-1.3145",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4348",
  "jasmine-runner": "static-1.6484",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.838",
  "hubspotter-http": "static-1.4667",
  "mobile-manifest-mixins": "static-1.538",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.733",
  "quartz-head": "static-1.723",
  "quartz-i18n": "static-1.733",
  "quartz-routing": "static-1.488",
  "quartz-test": "static-1.733",
  "quartz-tracking": "static-1.437",
  "ui-fonts": "static-1.755",
  "usage-tracker-container": "static-1.7356",
  "usage-tracker-core": "static-1.7216",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.156",
  "conversations-skeleton-state": "static-1.7268",
  "reference-resolvers": "static-1.8191",
  "sanitize-text": "static-1.8163",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10387",
  "sanitize": "static-1.4497",
  "outpost": "static-1.4201",
  "rpc-client-utils": "static-1.4673",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4247",
  "floating-ui": "static-1.56",
  "hs-story-utils": "static-1.9445",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.29",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.2013",
  "bend-plugin-foundations-theming": "static-1.2924",
  "foundations-theming-base": "static-1.3426",
  "stylex": "static-1.33",
  "hs-locale-management": "static-1.96",
  "csstype": "static-1.50",
  "web-vitals": "static-1.6",
  "ai-components-ui-library": "static-1.9035",
  "atom": "static-1.5093",
  "codemirror": "static-5.95",
  "content-assistance-lib": "static-1.7783",
  "ContentUtils": "static-1.68434",
  "data-token-picker": "static-1.16443",
  "file-manager-components": "static-1.23685",
  "FileManagerCore": "static-1.39184",
  "FileManagerLib": "static-1.39325",
  "frontend-preferences-client": "static-1.7948",
  "hub-http-contrib": "static-1.3063",
  "interframe": "static-3.4780",
  "layout-dnd-components": "static-1.12485",
  "layout-dnd-utils": "static-1.11460",
  "property-translator": "static-1.5420",
  "react-codemirror": "static-1.10647",
  "react-colorpicker": "static-2.10228",
  "reference-resolvers-lite": "static-1.8115",
  "rich-text-lib": "static-1.19869",
  "tinymce-data": "static-1.40519",
  "tinymce-themes": "static-1.56404",
  "ui-addon-emoji-picker": "static-1.9909",
  "ui-addon-sales-email": "static-1.5231",
  "ui-brand-identity-lib": "static-1.15373",
  "bender-build-tools": "static-1.3215",
  "hub-http-shared-msw-handlers": "static-1.10019",
  "hubspotter-http-shared-msw-handlers": "static-1.10017",
  "usage-tracker-session-replay": "static-1.5052",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.83",
  "chirp-fetch": "static-1.1908",
  "chatspot-core": "static-1.21412",
  "copilot-toolkit": "static-1.11193",
  "customer-data-objects-ui-components": "static-1.13049",
  "data-fetching-client": "static-1.9688",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4782",
  "ui-addon-video-player": "static-1.8723",
  "ui-coaching-tips": "static-1.28626",
  "usage-tracker": "static-1.7366",
  "cms-field-types": "static-1.4833",
  "content-icons-ui": "static-1.2233",
  "integrations-lib": "static-1.16223",
  "customer-data-objects": "static-1.7691",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4672",
  "apollo-stack-hubspot": "static-3.86",
  "graphql": "static-1.82",
  "immer": "static-1.33",
  "immerable": "static-1.4174",
  "ui-addon-iframeable": "static-1.9079",
  "video-components-external": "static-1.11349",
  "video-data-lib": "static-1.35007",
  "audio-components": "static-1.5946",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29334",
  "FileManagerImages": "static-1.36836",
  "foundations-components-legacy": "static-1.1003",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.525",
  "ui-universal-auth": "static-1.9003",
  "urlinator": "static-1.4557",
  "video-components": "static-1.13352",
  "video-embed": "static-1.35841",
  "ts-schema": "static-1.4095",
  "ContentData": "static-1.68509",
  "layout-data-lib": "static-1.9785",
  "react-dnd-compat": "static-1.4635",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1562",
  "external-options-client-types": "static-1.4175",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6905",
  "hs-promise-utils": "static-1.5611",
  "inbound-db-properties-service-client": "static-1.3862",
  "NamespacedHubStyle": "static-2.9074",
  "growth-onboarding-confetti": "static-1.3087",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11169",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5563",
  "magpie-types": "static-1.5023",
  "simple-logging-lib": "static-1.3071",
  "avatar-components": "static-1.2519",
  "customer-data-ui-utilities": "static-1.9847",
  "growth-onboarding-feedback-components": "static-1.6601",
  "flux-actions": "static-1.341",
  "hubspot-apollo-client": "static-1.4900",
  "integrations-error-boundary-lib": "static-1.13638",
  "integrations-tracking-lib": "static-1.5622",
  "laboratory-lib": "static-3.7176",
  "native-integrations-shared-strings": "static-1.7802",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10189",
  "unified-auth": "static-1.517",
  "navigation-messaging": "static-1.7430",
  "content-media-composition-data-lib": "static-1.12392",
  "content-media-compositions": "static-2.16399",
  "idb-keyval": "static-1.44",
  "media-bridge-lib": "static-1.18962",
  "unified-auth-core-lib": "static-1.799",
  "social-insights-client-types": "static-1.22181",
  "advanced-menus-core": "static-1.15160",
  "advanced-menus-lib": "static-1.12098",
  "ExportDialog": "static-6.10405",
  "ui-memberships-settings-lib": "static-1.34111",
  "conditional-properties-service-client": "static-1.3813",
  "crm-pipelines-api-client-types": "static-1.4155",
  "fdsr-migration-layer": "static-1.24",
  "framework-builder-read-service-client": "static-1.4021",
  "framework-data-schema-quick-fetch": "static-1.6810",
  "inbound-db-meta-service-client": "static-1.3602",
  "multi-currency-client-types": "static-1.3707",
  "persist-promise": "static-1.3719",
  "foundations-components-test-utils": "static-1.5461",
  "reactive-lib": "static-1.744",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.359",
  "universal-page-editor-lib": "static-1.3034",
  "google-sheets-integration-lib": "static-1.308",
  "microsoft-drive-integration-lib": "static-1.437",
  "slack-ui-library": "static-1.10413",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3752",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15159",
  "simple-menus-lib": "static-1.16676",
  "crm-record-cards-service-types": "static-1.3613",
  "location-customization-utils-lib": "static-1.9332",
  "react-flip-move": "static-1.70"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30318",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54632",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8034",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11493",
  "I18n": "/I18n/static-7-hdineen_hubspot-i18n-react-compiler.2",
  "quartz": "/quartz/static-1.7058",
  "quartz-config": "/quartz-config/static-1.836",
  "quartz-core": "/quartz-core/static-1.6277",
  "react-dlb": "/react-dlb/static-1.79",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.798",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54619",
  "feedback-utils": "/feedback-utils/static-1.54623",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4484",
  "forms-utils-lib": "/forms-utils-lib/static-1.12625",
  "foundations-assets": "/foundations-assets/static-1.4889",
  "foundations-components": "/foundations-components/static-1.7978",
  "foundations-theming": "/foundations-theming/static-1.4441",
  "hub-http": "/hub-http/static-1.6242",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11800",
  "icons": "/icons/static-2.650",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.3932",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.186",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1-feature-id-1459-skip-old-browsers.3",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5360",
  "react-virtualized": "/react-virtualized/static-2.99",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "tinymce-plugins": "/tinymce-plugins/static-1.57548",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1160",
  "UIComponents": "/UIComponents/static-3.8439",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3414",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3335",
  "quartz-webpack": "/quartz-webpack/static-1.3282",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2157",
  "property-description-translator": "/property-description-translator/static-1.3864",
  "HeadJS": "/HeadJS/static-2.764",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3145",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4348",
  "jasmine-runner": "/jasmine-runner/static-1.6484",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.838",
  "hubspotter-http": "/hubspotter-http/static-1.4667",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.733",
  "quartz-head": "/quartz-head/static-1.723",
  "quartz-i18n": "/quartz-i18n/static-1.733",
  "quartz-routing": "/quartz-routing/static-1.488",
  "quartz-test": "/quartz-test/static-1.733",
  "quartz-tracking": "/quartz-tracking/static-1.437",
  "ui-fonts": "/ui-fonts/static-1.755",
  "usage-tracker-container": "/usage-tracker-container/static-1.7356",
  "usage-tracker-core": "/usage-tracker-core/static-1.7216",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.156",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7268",
  "reference-resolvers": "/reference-resolvers/static-1.8191",
  "sanitize-text": "/sanitize-text/static-1.8163",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10387",
  "sanitize": "/sanitize/static-1.4497",
  "outpost": "/outpost/static-1.4201",
  "rpc-client-utils": "/rpc-client-utils/static-1.4673",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4247",
  "floating-ui": "/floating-ui/static-1.56",
  "hs-story-utils": "/hs-story-utils/static-1.9445",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.29",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.2013",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2924",
  "foundations-theming-base": "/foundations-theming-base/static-1.3426",
  "stylex": "/stylex/static-1.33",
  "hs-locale-management": "/hs-locale-management/static-1.96",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.6",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9035",
  "atom": "/atom/static-1.5093",
  "codemirror": "/codemirror/static-5.95",
  "content-assistance-lib": "/content-assistance-lib/static-1.7783",
  "ContentUtils": "/ContentUtils/static-1.68434",
  "data-token-picker": "/data-token-picker/static-1.16443",
  "file-manager-components": "/file-manager-components/static-1.23685",
  "FileManagerCore": "/FileManagerCore/static-1.39184",
  "FileManagerLib": "/FileManagerLib/static-1.39325",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7948",
  "hub-http-contrib": "/hub-http-contrib/static-1.3063",
  "interframe": "/interframe/static-3.4780",
  "layout-dnd-components": "/layout-dnd-components/static-1.12485",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11460",
  "property-translator": "/property-translator/static-1.5420",
  "react-codemirror": "/react-codemirror/static-1.10647",
  "react-colorpicker": "/react-colorpicker/static-2.10228",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8115",
  "rich-text-lib": "/rich-text-lib/static-1.19869",
  "tinymce-data": "/tinymce-data/static-1.40519",
  "tinymce-themes": "/tinymce-themes/static-1.56404",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9909",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5231",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15373",
  "bender-build-tools": "/bender-build-tools/static-1.3215",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10019",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10017",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5052",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.83",
  "chirp-fetch": "/chirp-fetch/static-1.1908",
  "chatspot-core": "/chatspot-core/static-1.21412",
  "copilot-toolkit": "/copilot-toolkit/static-1.11193",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13049",
  "data-fetching-client": "/data-fetching-client/static-1.9688",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4782",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8723",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28626",
  "usage-tracker": "/usage-tracker/static-1.7366",
  "cms-field-types": "/cms-field-types/static-1.4833",
  "content-icons-ui": "/content-icons-ui/static-1.2233",
  "integrations-lib": "/integrations-lib/static-1.16223",
  "customer-data-objects": "/customer-data-objects/static-1.7691",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4672",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
  "graphql": "/graphql/static-1.82",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4174",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9079",
  "video-components-external": "/video-components-external/static-1.11349",
  "video-data-lib": "/video-data-lib/static-1.35007",
  "audio-components": "/audio-components/static-1.5946",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29334",
  "FileManagerImages": "/FileManagerImages/static-1.36836",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1003",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.525",
  "ui-universal-auth": "/ui-universal-auth/static-1.9003",
  "urlinator": "/urlinator/static-1.4557",
  "video-components": "/video-components/static-1.13352",
  "video-embed": "/video-embed/static-1.35841",
  "ts-schema": "/ts-schema/static-1.4095",
  "ContentData": "/ContentData/static-1.68509",
  "layout-data-lib": "/layout-data-lib/static-1.9785",
  "react-dnd-compat": "/react-dnd-compat/static-1.4635",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1562",
  "external-options-client-types": "/external-options-client-types/static-1.4175",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6905",
  "hs-promise-utils": "/hs-promise-utils/static-1.5611",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3862",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9074",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3087",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11169",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5563",
  "magpie-types": "/magpie-types/static-1.5023",
  "simple-logging-lib": "/simple-logging-lib/static-1.3071",
  "avatar-components": "/avatar-components/static-1.2519",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9847",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6601",
  "flux-actions": "/flux-actions/static-1.341",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4900",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13638",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5622",
  "laboratory-lib": "/laboratory-lib/static-3.7176",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7802",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10189",
  "unified-auth": "/unified-auth/static-1.517",
  "navigation-messaging": "/navigation-messaging/static-1.7430",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12392",
  "content-media-compositions": "/content-media-compositions/static-2.16399",
  "idb-keyval": "/idb-keyval/static-1.44",
  "media-bridge-lib": "/media-bridge-lib/static-1.18962",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.799",
  "social-insights-client-types": "/social-insights-client-types/static-1.22181",
  "advanced-menus-core": "/advanced-menus-core/static-1.15160",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12098",
  "ExportDialog": "/ExportDialog/static-6.10405",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34111",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3813",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4155",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.24",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4021",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6810",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3602",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3707",
  "persist-promise": "/persist-promise/static-1.3719",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5461",
  "reactive-lib": "/reactive-lib/static-1.744",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.359",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3034",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.308",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.437",
  "slack-ui-library": "/slack-ui-library/static-1.10413",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3752",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15159",
  "simple-menus-lib": "/simple-menus-lib/static-1.16676",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3613",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9332",
  "react-flip-move": "/react-flip-move/static-1.70"
}
};
